import React from "react";
import { motion } from "framer-motion";

const ease = [0.16, 1, 0.3, 1];

// Scroll-triggered reveal
export const Reveal = ({ children, delay = 0, y = 28, className = "", once = true }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-80px" }}
    transition={{ duration: 0.9, ease, delay }}
    className={className}
  >
    {children}
  </motion.div>
);

// Line-by-line masked reveal for large headings
export const MaskLines = ({ lines, className = "", lineClassName = "", stagger = 0.12, delay = 0.1 }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="line-mask">
        <motion.span
          className={`block ${lineClassName}`}
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1.1, ease, delay: delay + i * stagger }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

export const FadeUp = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.9, ease, delay }}
    className={className}
  >
    {children}
  </motion.div>
);
